import React from 'react';
import { 
  Heart, 
  Star, 
  Play, 
  Camera, 
  Music, 
  Video,
  ArrowLeft,
  Maximize2,
  Minimize2
} from 'lucide-react';

const IconTest = () => {
  return (
    <div style={{ padding: '2rem', fontFamily: 'Arial, sans-serif' }}>
      <h1>Icon Test - Lucide React</h1>
      <p>Testing if lucide-react icons are working properly...</p>
      
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1rem', marginTop: '2rem' }}>
        <div style={{ padding: '1rem', border: '1px solid #ccc', borderRadius: '8px', textAlign: 'center' }}>
          <Heart size={32} color="red" />
          <p>Heart Icon</p>
        </div>
        
        <div style={{ padding: '1rem', border: '1px solid #ccc', borderRadius: '8px', textAlign: 'center' }}>
          <Star size={32} color="gold" />
          <p>Star Icon</p>
        </div>
        
        <div style={{ padding: '1rem', border: '1px solid #ccc', borderRadius: '8px', textAlign: 'center' }}>
          <Play size={32} color="blue" />
          <p>Play Icon</p>
        </div>
        
        <div style={{ padding: '1rem', border: '1px solid #ccc', borderRadius: '8px', textAlign: 'center' }}>
          <Camera size={32} color="green" />
          <p>Camera Icon</p>
        </div>
        
        <div style={{ padding: '1rem', border: '1px solid #ccc', borderRadius: '8px', textAlign: 'center' }}>
          <Music size={32} color="purple" />
          <p>Music Icon</p>
        </div>
        
        <div style={{ padding: '1rem', border: '1px solid #ccc', borderRadius: '8px', textAlign: 'center' }}>
          <Video size={32} color="orange" />
          <p>Video Icon</p>
        </div>
        
        <div style={{ padding: '1rem', border: '1px solid #ccc', borderRadius: '8px', textAlign: 'center' }}>
          <ArrowLeft size={32} color="black" />
          <p>Arrow Left Icon</p>
        </div>
        
        <div style={{ padding: '1rem', border: '1px solid #ccc', borderRadius: '8px', textAlign: 'center' }}>
          <Maximize2 size={32} color="teal" />
          <p>Maximize Icon</p>
        </div>
        
        <div style={{ padding: '1rem', border: '1px solid #ccc', borderRadius: '8px', textAlign: 'center' }}>
          <Minimize2 size={32} color="brown" />
          <p>Minimize Icon</p>
        </div>
      </div>
      
      <div style={{ marginTop: '2rem', padding: '1rem', backgroundColor: '#f0f0f0', borderRadius: '8px' }}>
        <h3>If you see icons above:</h3>
        <p>✅ lucide-react is working correctly</p>
        <p>✅ The issue is elsewhere in the main component</p>
        
        <h3>If you don't see icons above:</h3>
        <p>❌ There's an issue with lucide-react installation</p>
        <p>❌ We need to reinstall or use a different icon library</p>
      </div>
    </div>
  );
};

export default IconTest;
